import Vue from 'vue'
import moment from 'moment'

Vue.filter('toMonthYearString', function (original) {
  if (original !== null) {
    let retValue = moment(original)
    retValue.locale('de')
    return retValue.format('M/YYYY')
  }
  return original
})



// WEBPACK FOOTER //
// ./src/filters/toMonthYearString.js